module.exports = __webpack_public_path__ + "img/icon_awardmember_yellow.9f8de460.svg";